/*
 * File: cell-cron.ts
 * File Created: 2024-03-14 11:00:12
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { Component } from "vue-property-decorator";

@Component
@UITag.setDefault({
    uiSort: true,
})
export default class CellCron extends BaseTableBodyCell {
    text = null;
}
